import {NavTree} from "./nav.tree";
import {NavItem} from "./nav.item";
import {Paths} from "../../paths";

export class NavUser {

  public static build(): NavTree {
    // ########################################################################
    // #### Overview
    // ########################################################################
    const overview = new NavItem({
      id: 'overview-main',
      title: 'overview.name',
      icon: 'dashboard',
      route: Paths.OVERVIEW,
      paths: [Paths.OVERVIEW],
    });

    // ########################################################################
    // #### Organisation(s)
    // ########################################################################
    const org = new NavItem({
      id: 'org-main',
      title: 'orgs',
      icon: 'org',
      route: Paths.ORG_LIST,
      paths: [Paths.ORG_LIST, Paths.ORG_ADD, Paths.ORG_ADD_SUCCESS]
    });

    const items: NavItem[] = [
      overview,
      org
    ];

    return new NavTree(items);
  }
}
